import { SubpropertyService } from '@modules/subproperty/subproperty-service';
import Errors from '@shared/error/errors';
import ManageModel from '@shared/manage/manage-model';

export default {
  namespaced: true,

  state: {
    rows: [],
    loading: false,
    currentPos: 0, 
  },

  getters: {
    currentPos: (state) => state.currentPos,

    loading: (state) => state.loading,

    rows: (state) => state.rows || [],
  },

  mutations: {
    RESETED(state) {
      state.rows = null;
      state.loading = false;
      state.currentPos = 0;
    },

    FETCH_STARTED(state) {
      state.loading = true;
    },

    FETCH_SUCCESS(state, payload) {
      state.loading = false;
      state.rows = payload.rows;
    },

    FETCH_ERROR(state) {
      state.loading = false;
      state.rows = [];
      state.count = 0;
    },

    SET_CURRENT_POS(state, currentPos) {
      state.loading = false;
      state.currentPos = currentPos;
    },
  },

  actions: {
    doChangeCurrentPos({ commit }, { currentPos}) {
      commit('SET_CURRENT_POS', currentPos);
    },

    async doReset({ commit, dispatch }) {
      commit('RESETED');
      return dispatch('doFetch');
    },

    async doFetch(
      { commit, rootGetters },
    ) {
      try {
        //commit('RESETED');
        commit('RESETED');
        commit('FETCH_STARTED');

        const currentManage = rootGetters['auth/manage/currentManage'];
        const manageInput = new ManageModel(currentManage).getManageModel()
        const response = await SubpropertyService.list(
          null,
          null,
          0,
          0,
          manageInput
        );        

        commit('FETCH_SUCCESS', {
          rows: response.rows,
        });
      } catch (error) {
        Errors.handle(error);
        commit('FETCH_ERROR');
      }
    },
  },
};
